import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Nav } from "../components/Nav";
import { useLang } from "../i18n";
import { api } from "../api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LegalInfo } from "../components/LegalInfo";
import { FooterLinks } from "../components/FooterLinks";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch (e2) {
      // intentionally generic: never reveal if email exists
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <div className="App min-h-screen">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-serif text-4xl tracking-tight text-[#2B4A59] mb-2">{t("forgot_title")}</h1>
        <p className="text-[#6E6B65] mb-8">{t("forgot_sub")}</p>

        {sent ? (
          <div className="rounded-2xl p-6 bg-[#EAF0EC] border border-[#cfe0d6] flex gap-3" data-testid="forgot-sent">
            <MailCheck className="w-6 h-6 text-[#3B604E] shrink-0" />
            <p className="text-sm text-[#2f4a3d]">{t("forgot_sent")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
            <div>
              <Label htmlFor="forgot-email">{t("email")}</Label>
              <Input id="forgot-email" name="email" autoComplete="email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-lg h-12 text-base md:text-base mt-1" />
            </div>
            <Button data-testid="forgot-submit" type="submit" disabled={busy} className="w-full rounded-full bg-[#3F6E85] hover:bg-[#2B4A59] h-12">
              {busy ? "..." : t("forgot_send")}
            </Button>
          </form>
        )}

        <p className="text-sm text-[#6E6B65] mt-6">
          <Link to="/login" className="text-[#B5651D] font-semibold" data-testid="forgot-back-login">{t("login")}</Link>
        </p>
        <FooterLinks className="mt-8 pt-6 border-t border-stone-200 flex flex-wrap gap-x-5 gap-y-2 text-[14px] text-[#6E6B65]" />
        <LegalInfo />
      </div>
    </div>
  );
}
